<script>
import gql from "graphql-tag";
import { tournamentCompetitorFragment } from "@/graphql/tournament";
import { DialogInputTypes } from "@/js/helper";
import BaseUpsertDialog from "./baseUpsertDialog.vue";

export default {
  name: "UpdateCompetitorDialog",
  extends: BaseUpsertDialog,
  props: { tournament: Object, competitor: Object },
  data: function() {
    return {
      name: { label: "Name" },
      description: { label: "Description" },
      rank: { label: "Rank", type: DialogInputTypes.number },
      points: { label: "Points", type: DialogInputTypes.number },
      amountPaid: { label: "Amount paid", type: DialogInputTypes.number },
      isActive: {
        label: "Is active",
        type: DialogInputTypes.bool,
        hint: "Inactive competitors will not be included in new draws"
      },
      isEliminated: {
        label: "Is eliminated from competition",
        type: DialogInputTypes.bool
      },
      results: { label: "Result sequence", disabled: true }
    };
  },
  computed: {
    dialogInputs: {
      get() {
        return [
          this.name,
          this.description,
          this.rank,
          this.points,
          this.amountPaid,
          this.isActive,
          this.isEliminated,
          this.results
        ];
      }
    },
    title: {
      get() {
        return `Edit competitor - ${this.competitor.name}`;
      }
    },
    instructions: {
      get() {
        return "Use this form to manual update the properties of the competitor.";
      }
    },
    entity: {
      get() {
        return this.competitor;
      }
    }
  },
  methods: {
    customCopyValues() {
      this.results.value =
        this.competitor.resultSequence &&
        this.competitor.resultSequence.join(", ");
    },
    submit() {
      return this.$apollo
        .mutate({
          mutation: gql`
            mutation($tournamentId: ID!, $competitor: CompetitorInput!) {
              upsertCompetitor(
                tournamentId: $tournamentId
                competitor: $competitor
              ) {
                ...TournamentCompetitor
              }
            }
            ${tournamentCompetitorFragment}
          `,
          variables: {
            tournamentId: this.tournament.id,
            competitor: {
              id: this.competitor.id,
              name: this.name.value,
              description: this.description.value,
              rank: this.rank.value,
              points: this.points.value,
              amountPaid: this.amountPaid.value,
              isActive: this.isActive.value,
              isEliminated: this.isEliminated.value
            }
          }
        })
        .then(result => {
          this.$root.$emit("updateTournament", this.tournament.id);
          this.$store.commit(
            "setNotification",
            `Competitor ${this.competitor.name} updated`
          );
        })
        .catch(err => {
          console.log(err);
          window.alert("Failed to update the competitor");
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// updateCompetitorDialog.vue?736bb144